export default "__VITE_ASSET__DmGa2gSM__"